<div class="d-flex justify-content-end pb-4">
    <button
        *ngIf="isCancelVisible"
        (click)="btnClicked(USER_PROFILE_BUTTON_TYPE.CANCEL)"
        type="button"
        class="btn btn-outline-secondary font-weight-bold font-size-14 px-4 py-2 mr-4 selenium-cancel-edit-btn"
    >
        Cancel
    </button>
    <button
        [disabled]="isSaveDisabled"
        (click)="btnClicked(USER_PROFILE_BUTTON_TYPE.SAVE)"
        type="button"
        class="btn btn-primary font-weight-bold font-size-14 px-4 py-2 selenium-edit-or-save-btn"
    >
        Save Changes
    </button>
</div>
